












import { Component, Vue } from "vue-property-decorator";
import uploadNew from "@/components/uploadNew.vue";
import api from "@/api";
import {imageUrl} from '@/utils/common'
import jifenShop from './components/jifenShop.vue'
import ziyingShop from './components/ziyingShop.vue'

@Component({
  components: {
    uploadNew: uploadNew,
    jifenShop,
    ziyingShop
  }
})
export default class Commodity extends Vue {
  activeName='jifenShop'
  

  activated() {
  }
}
